import FastModal from 'components/FastModal';
import ElementPrefixId from 'constants/elementPrefixId';
import {useIntl} from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';
import {hideTypedModal} from 'stores/actions/typedModalAction';
import {FmlxCheckBox} from 'fmlx-common-ui';
import {useState} from 'react';
import {setInstrumentNonOperationalModalConfig} from 'stores/business/errorHandlers/serviceErrorBusiness';
import {selectSessionUserId} from 'stores/selectors/sessionSelectors';
import style from './ModalServiceError.module.scss';

function ModalInstrumentNonOperational() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();
  const [isCheckedValue, setIsCheckedValue] = useState(false);
  const userId = useSelector(selectSessionUserId);

  const content = (
    <div id={`${ElementPrefixId.MODAL_INSTRUMENT_NON_OPERATIONAL}-container`} className={style.container}>
      <span className={style.description}>
        {formatMessage({id: 'modal.instrumentNonOperational.text.restartInstrument'})}
      </span>
      <div className={style.checkbox}>
        <FmlxCheckBox
          onChange={(e) => setIsCheckedValue(e.target.checked)}
          label={formatMessage({
            id: 'modal.instrumentNonOperational.text.radioButton',
          })}
          checked={isCheckedValue}
        />
      </div>
    </div>
  );

  const handleClickClose = () => {
    setInstrumentNonOperationalModalConfig({[userId]: isCheckedValue});
    dispatch(hideTypedModal());
  };

  const buttons = [
    {
      className: 'btn-lg',
      style: 'primary',
      text: formatMessage({id: 'modal.instrumentNonOperational.button'}),
      handlerClick: handleClickClose,
    },
  ];

  return (
    <FastModal
      show
      header={formatMessage({id: 'modal.instrumentNonOperational.title'})}
      content={content}
      btnAction={buttons}
      size="md"
      closeDisabled={false}
      onClose={handleClickClose}
    />
  );
}

export default ModalInstrumentNonOperational;
